import { useEffect } from "react";

export const useEvent = (event: string, callback: EventListenerOrEventListenerObject) => {
    useEffect(() => {
        addEventListener(event, callback);
        return () => removeEventListener(event, callback);
    }, [event, callback]);
}

export default useEvent;